import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-aed395ac"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "event-page"
};
const _hoisted_2 = {
  class: "dialog-heading"
};
const _hoisted_3 = {
  key: 0,
  class: "detail-shell"
};
const _hoisted_4 = {
  class: "detail-hero"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "detail-label"
}, "活动时间", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "detail-label"
}, "二课分", -1));
const _hoisted_7 = {
  class: "detail-grid"
};
const _hoisted_8 = {
  class: "detail-item wide"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "活动简介", -1));
const _hoisted_10 = {
  class: "detail-item"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "报名时间", -1));
const _hoisted_12 = {
  class: "detail-item"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "参与人数", -1));
const _hoisted_14 = {
  class: "detail-item"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "签到统计", -1));
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "签到 / 签退", -1));
const _hoisted_17 = {
  class: "detail-item"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "定位签到", -1));
const _hoisted_19 = {
  class: "detail-item"
};
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "需要签退", -1));
const _hoisted_21 = {
  class: "sign-panel"
};
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "sign-panel-head"
}, [/*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("h4", null, "签到信息")])], -1));
const _hoisted_23 = {
  class: "sign-grid"
};
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "活动 ID", -1));
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "签到方式", -1));
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "签退要求", -1));
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "报名状态", -1));
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "可执行动作", -1));
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "签到状态", -1));
const _hoisted_30 = {
  class: "local-sign-box"
};
const _hoisted_31 = {
  class: "local-sign-copy"
};
const _hoisted_32 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "本地签到接口", -1));
const _hoisted_33 = {
  key: 0
};
const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("code", null, "/apis/activity/signIn", -1));
const _hoisted_35 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("code", null, "/apis/activity/signInGps", -1));
const _hoisted_36 = {
  key: 1
};
const _hoisted_37 = {
  key: 0,
  class: "sign-result-text"
};
const _hoisted_38 = {
  key: 1,
  class: "sign-result-text"
};
const _hoisted_39 = {
  class: "sign-panel-actions"
};
const _hoisted_40 = {
  class: "event-admin-box"
};
const _hoisted_41 = {
  class: "local-sign-copy"
};
const _hoisted_42 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "成员列表 / 签到员设置", -1));
const _hoisted_43 = {
  key: 0
};
const _hoisted_44 = {
  key: 1
};
const _hoisted_45 = {
  key: 2
};
const _hoisted_46 = {
  class: "event-admin-form"
};
const _hoisted_47 = {
  key: 0,
  class: "sign-result-text"
};
const _hoisted_48 = {
  key: 1,
  class: "manager-member-list"
};
const _hoisted_49 = ["onClick"];
const _hoisted_50 = {
  key: 0
};
const _hoisted_51 = {
  key: 1
};
const _hoisted_52 = {
  key: 2
};
const _hoisted_53 = {
  key: 3
};
const _hoisted_54 = {
  key: 4
};
const _hoisted_55 = {
  class: "member-pagination"
};
const _hoisted_56 = {
  class: "sign-panel-actions"
};
const _hoisted_57 = {
  key: 0,
  class: "activity-extra-box"
};
const _hoisted_58 = {
  class: "activity-extra-head"
};
const _hoisted_59 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("h4", null, "补充活动接口")], -1));
const _hoisted_60 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "extra-hint"
}, " 已接入公告、评价、投票成员、报名资料、中途签到状态/记录等只读接口；不会自动执行发布、评价或中途签到。 ", -1));
const _hoisted_61 = {
  class: "extra-grid"
};
const _hoisted_62 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "公告", -1));
const _hoisted_63 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "评价", -1));
const _hoisted_64 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "投票项", -1));
const _hoisted_65 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "中途签到", -1));
const _hoisted_66 = {
  key: 0,
  class: "sign-result-text"
};
const _hoisted_67 = {
  class: "danger-action-box"
};
const _hoisted_68 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "local-sign-copy"
}, [/*#__PURE__*/_createElementVNode("strong", null, "写入操作"), /*#__PURE__*/_createElementVNode("span", null, " 发布公告、提交评价、投票、中途签到都是真实写入；点击前会二次确认，权限由服务端判定。 ")], -1));
const _hoisted_69 = {
  class: "danger-action-grid"
};
const _hoisted_70 = {
  key: 1,
  class: "extra-list"
};
const _hoisted_71 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "报名资料要求", -1));
const _hoisted_72 = {
  key: 2,
  class: "extra-list"
};
const _hoisted_73 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "活动公告", -1));
const _hoisted_74 = {
  key: 0
};
const _hoisted_75 = {
  key: 3,
  class: "extra-list"
};
const _hoisted_76 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "活动评价", -1));
const _hoisted_77 = {
  key: 0
};
const _hoisted_78 = {
  key: 4,
  class: "extra-list"
};
const _hoisted_79 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "投票 / 参赛项", -1));
const _hoisted_80 = {
  key: 5,
  class: "extra-list"
};
const _hoisted_81 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "中途签到记录", -1));
const _hoisted_82 = {
  key: 0
};
const _hoisted_83 = {
  class: "detail-actions"
};
const _hoisted_84 = {
  class: "event-console glass-panel"
};
const _hoisted_85 = {
  class: "event-toolbar"
};
const _hoisted_86 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("h2", null, "活动"), /*#__PURE__*/_createElementVNode("p", null, "搜索校园活动，或筛选可签到、我的、管理与收藏。")], -1));
const _hoisted_87 = {
  class: "search-actions"
};
const _hoisted_88 = {
  class: "event-stats"
};
const _hoisted_89 = {
  class: "metric-card"
};
const _hoisted_90 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "metric-label"
}, "当前页", -1));
const _hoisted_91 = {
  class: "metric-value"
};
const _hoisted_92 = {
  class: "metric-card"
};
const _hoisted_93 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "metric-label"
}, "本页活动", -1));
const _hoisted_94 = {
  class: "metric-value"
};
const _hoisted_95 = {
  class: "metric-card"
};
const _hoisted_96 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "metric-label"
}, "可报名", -1));
const _hoisted_97 = {
  class: "metric-value"
};
const _hoisted_98 = {
  class: "activity-board glass-panel"
};
const _hoisted_99 = {
  key: 0,
  class: "activity-list"
};
const _hoisted_100 = ["onClick"];
const _hoisted_101 = {
  class: "activity-main"
};
const _hoisted_102 = {
  class: "activity-id"
};
const _hoisted_103 = {
  class: "activity-meta"
};
const _hoisted_104 = {
  class: "activity-time"
};
const _hoisted_105 = {
  class: "pagination"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_input_number = _resolveComponent("el-input-number");
  const _component_el_dialog = _resolveComponent("el-dialog");
  const _component_el_empty = _resolveComponent("el-empty");
  const _directive_loading = _resolveDirective("loading");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
    modelValue: $setup.detailDialogVisible,
    "onUpdate:modelValue": _cache[26] || (_cache[26] = $event => $setup.detailDialogVisible = $event),
    width: "760px",
    "align-center": "",
    "destroy-on-close": "",
    class: "soft-dialog"
  }, {
    header: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("h3", null, _toDisplayString($setup.detailInfo?.name || '活动详情'), 1)])]),
    default: _withCtx(() => [$setup.detailInfo ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", null, [_hoisted_5, _createElementVNode("strong", null, _toDisplayString($setup.formatTime($setup.detailInfo.startTime)), 1), _createElementVNode("span", null, _toDisplayString($setup.formatTime($setup.detailInfo.endTime)), 1)]), _createElementVNode("div", null, [_hoisted_6, _createElementVNode("strong", null, _toDisplayString($setup.displayValue($setup.detailInfo.credit)), 1), _createElementVNode("span", null, _toDisplayString($setup.detailInfo.location || '未填写地点'), 1)])]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_hoisted_9, _createElementVNode("p", null, _toDisplayString($setup.detailInfo.descs || '暂无简介'), 1)]), _createElementVNode("div", _hoisted_10, [_hoisted_11, _createElementVNode("strong", null, _toDisplayString($setup.formatTime($setup.detailInfo.regStartTimeStr)), 1), _createElementVNode("small", null, _toDisplayString($setup.formatTime($setup.detailInfo.regEndTimeStr)), 1)]), _createElementVNode("div", _hoisted_12, [_hoisted_13, _createElementVNode("strong", null, _toDisplayString($setup.detailInfo.joinNum) + " / " + _toDisplayString($setup.detailInfo.joinNum + $setup.detailInfo.leftNum), 1), _createElementVNode("small", null, "剩余 " + _toDisplayString($setup.detailInfo.leftNum) + " 人", 1)]), _createElementVNode("div", _hoisted_14, [_hoisted_15, _createElementVNode("strong", null, _toDisplayString($setup.detailInfo.sign_in_num) + " / " + _toDisplayString($setup.detailInfo.sign_out_num), 1), _hoisted_16]), _createElementVNode("div", _hoisted_17, [_hoisted_18, _createElementVNode("strong", null, _toDisplayString($setup.convert($setup.detailInfo.is_gps_sign)), 1)]), _createElementVNode("div", _hoisted_19, [_hoisted_20, _createElementVNode("strong", null, _toDisplayString($setup.convert($setup.detailInfo.is_need_sign_out)), 1)])]), _createElementVNode("section", _hoisted_21, [_hoisted_22, _createElementVNode("div", _hoisted_23, [_createElementVNode("div", null, [_hoisted_24, _createElementVNode("strong", null, _toDisplayString($setup.currentDetailId || '—'), 1)]), _createElementVNode("div", null, [_hoisted_25, _createElementVNode("strong", null, _toDisplayString($setup.signMethodText), 1)]), _createElementVNode("div", null, [_hoisted_26, _createElementVNode("strong", null, _toDisplayString($setup.convert($setup.detailInfo.is_need_sign_out)), 1)]), _createElementVNode("div", null, [_hoisted_27, _createElementVNode("strong", null, _toDisplayString($setup.joinStatusText), 1)]), _createElementVNode("div", null, [_hoisted_28, _createElementVNode("strong", null, _toDisplayString($setup.detailInfo.joinInfo?.name || '—'), 1)]), _createElementVNode("div", null, [_hoisted_29, _createElementVNode("strong", null, _toDisplayString($setup.userSignStatusText), 1)])]), _createElementVNode("div", _hoisted_30, [_createElementVNode("div", _hoisted_31, [_hoisted_32, $setup.canUseLocalSign ? (_openBlock(), _createElementBlock("span", _hoisted_33, [_createTextVNode("扫码/普通签到走 "), _hoisted_34, _createTextVNode("，GPS 定位签到走 "), _hoisted_35, _createTextVNode("，两者已分开。")])) : (_openBlock(), _createElementBlock("span", _hoisted_36, "该接口需要新版 Class 登录；传统 Web 登录暂不支持本地签到。"))]), _createVNode(_component_el_input, {
      modelValue: $setup.signAddress,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $setup.signAddress = $event),
      clearable: "",
      disabled: !$setup.canSubmitGpsSign || $setup.signLoading,
      placeholder: "GPS 签到地点 / 地址；扫码签到无需填写"
    }, null, 8, ["modelValue", "disabled"]), $setup.signResultText ? (_openBlock(), _createElementBlock("p", _hoisted_37, _toDisplayString($setup.signResultText), 1)) : _createCommentVNode("", true), $setup.lastActionMessage ? (_openBlock(), _createElementBlock("p", _hoisted_38, _toDisplayString($setup.lastActionMessage), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_39, [_createVNode(_component_el_button, {
      onClick: _cache[1] || (_cache[1] = $event => $setup.copySignInfo($setup.detailInfo))
    }, {
      default: _withCtx(() => [_createTextVNode("复制活动信息")]),
      _: 1
    }), _createVNode(_component_el_button, {
      disabled: !$setup.canSubmitGpsSign || $setup.signLoading,
      loading: $setup.locating,
      onClick: $setup.fillCurrentLocation
    }, {
      default: _withCtx(() => [_createTextVNode(" 获取当前位置 ")]),
      _: 1
    }, 8, ["disabled", "loading", "onClick"]), _createVNode(_component_el_button, {
      type: "primary",
      disabled: !$setup.canUseLocalSign || !$setup.currentDetailId,
      loading: $setup.signLoading && $setup.signAction === 'qr-in',
      onClick: _cache[2] || (_cache[2] = $event => $setup.submitLocalSign('qr-in'))
    }, {
      default: _withCtx(() => [_createTextVNode(" 扫码签到（本人） ")]),
      _: 1
    }, 8, ["disabled", "loading"]), _createVNode(_component_el_button, {
      type: "warning",
      plain: "",
      disabled: !$setup.canUseLocalSign || !$setup.currentDetailId,
      loading: $setup.signLoading && $setup.signAction === 'qr-out',
      onClick: _cache[3] || (_cache[3] = $event => $setup.submitLocalSign('qr-out'))
    }, {
      default: _withCtx(() => [_createTextVNode(" 扫码签退（本人） ")]),
      _: 1
    }, 8, ["disabled", "loading"]), _createVNode(_component_el_button, {
      type: "primary",
      plain: "",
      disabled: !$setup.canSubmitGpsSign || $setup.locating,
      loading: $setup.signLoading && $setup.signAction === 'gps-in',
      onClick: _cache[4] || (_cache[4] = $event => $setup.submitLocalSign('gps-in'))
    }, {
      default: _withCtx(() => [_createTextVNode(" GPS 定位签到 ")]),
      _: 1
    }, 8, ["disabled", "loading"]), _createVNode(_component_el_button, {
      type: "warning",
      plain: "",
      disabled: !$setup.canSubmitGpsSign || $setup.locating,
      loading: $setup.signLoading && $setup.signAction === 'gps-out',
      onClick: _cache[5] || (_cache[5] = $event => $setup.submitLocalSign('gps-out'))
    }, {
      default: _withCtx(() => [_createTextVNode(" GPS 定位签退 ")]),
      _: 1
    }, 8, ["disabled", "loading"])]), _createElementVNode("div", _hoisted_40, [_createElementVNode("div", _hoisted_41, [_hoisted_42, $setup.canUseLocalSign ? (_openBlock(), _createElementBlock("span", _hoisted_43, " 当前 Class 登录可查看成员列表；签到员/工作人员设置仍需旧版 Web 管理权限。 ")) : $setup.canUseLegacyEventAdmin ? (_openBlock(), _createElementBlock("span", _hoisted_44, " 旧版 Web 官方接口，仅活动管理员或组织者有权限；目标必须是已报名成员 UID。 ")) : (_openBlock(), _createElementBlock("span", _hoisted_45, "请先使用 Class 或旧版 Web 登录后查看成员列表。"))]), _createElementVNode("div", _hoisted_46, [_createVNode(_component_el_input, {
      modelValue: $setup.managerTargetUid,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $setup.managerTargetUid = $event),
      clearable: "",
      disabled: !$setup.canUseLegacyEventAdmin || $setup.managerLoading,
      placeholder: "成员 UID（不是学号）"
    }, null, 8, ["modelValue", "disabled"]), _createVNode(_component_el_input, {
      modelValue: $setup.memberKeyword,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $setup.memberKeyword = $event),
      clearable: "",
      disabled: !$setup.canUseLegacyEventAdmin || $setup.memberListLoading,
      placeholder: $setup.canUseLegacyEventAdmin ? '按姓名查询成员' : 'Class 成员列表暂不支持姓名过滤'
    }, null, 8, ["modelValue", "disabled", "placeholder"]), _createVNode(_component_el_button, {
      disabled: !$setup.canViewEventMembers || !$setup.currentDetailId,
      loading: $setup.memberListLoading,
      onClick: _cache[8] || (_cache[8] = $event => $setup.loadEventMembers(1))
    }, {
      default: _withCtx(() => [_createTextVNode(" 查成员 ")]),
      _: 1
    }, 8, ["disabled", "loading"])]), $setup.memberTotalText ? (_openBlock(), _createElementBlock("p", _hoisted_47, _toDisplayString($setup.memberTotalText), 1)) : _createCommentVNode("", true), $setup.managerMembers.length ? (_openBlock(), _createElementBlock("div", _hoisted_48, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.managerMembers, member => {
      return _openBlock(), _createElementBlock("button", {
        key: member.id || member.uid,
        type: "button",
        onClick: $event => $setup.managerTargetUid = String(member.uid || '')
      }, [_createTextVNode(_toDisplayString(member.realname || '未命名') + " #" + _toDisplayString(member.uid || '—') + " ", 1), member.college ? (_openBlock(), _createElementBlock("small", _hoisted_50, _toDisplayString(member.college), 1)) : _createCommentVNode("", true), member.class ? (_openBlock(), _createElementBlock("small", _hoisted_51, _toDisplayString(member.class), 1)) : _createCommentVNode("", true), member.signName ? (_openBlock(), _createElementBlock("span", _hoisted_52, _toDisplayString(member.signName), 1)) : _createCommentVNode("", true), String(member.is_sign_manager) === '1' ? (_openBlock(), _createElementBlock("span", _hoisted_53, "签到员")) : _createCommentVNode("", true), Number(member.is_organiser) === 1 ? (_openBlock(), _createElementBlock("span", _hoisted_54, "组织者")) : _createCommentVNode("", true)], 8, _hoisted_49);
    }), 128))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_55, [_createVNode(_component_el_button, {
      size: "small",
      disabled: !$setup.memberHasPrev || $setup.memberListLoading,
      onClick: _cache[9] || (_cache[9] = $event => $setup.loadEventMembers($setup.memberPage - 1))
    }, {
      default: _withCtx(() => [_createTextVNode(" 上一页成员 ")]),
      _: 1
    }, 8, ["disabled"]), _createElementVNode("span", null, "第 " + _toDisplayString($setup.memberPage) + " 页", 1), _createVNode(_component_el_button, {
      size: "small",
      disabled: !$setup.memberHasNext || $setup.memberListLoading,
      onClick: _cache[10] || (_cache[10] = $event => $setup.loadEventMembers($setup.memberPage + 1))
    }, {
      default: _withCtx(() => [_createTextVNode(" 下一页成员 ")]),
      _: 1
    }, 8, ["disabled"])]), _createElementVNode("div", _hoisted_56, [_createVNode(_component_el_button, {
      type: "primary",
      plain: "",
      disabled: !$setup.canUseLegacyEventAdmin || !$setup.managerTargetUid || !$setup.currentDetailId,
      loading: $setup.managerLoading && $setup.managerAction === 'set-sign',
      onClick: _cache[11] || (_cache[11] = $event => $setup.submitLegacyManagerAction('set-sign'))
    }, {
      default: _withCtx(() => [_createTextVNode(" 设为签到员 ")]),
      _: 1
    }, 8, ["disabled", "loading"]), _createVNode(_component_el_button, {
      plain: "",
      disabled: !$setup.canUseLegacyEventAdmin || !$setup.managerTargetUid || !$setup.currentDetailId,
      loading: $setup.managerLoading && $setup.managerAction === 'cancel-sign',
      onClick: _cache[12] || (_cache[12] = $event => $setup.submitLegacyManagerAction('cancel-sign'))
    }, {
      default: _withCtx(() => [_createTextVNode(" 取消签到员 ")]),
      _: 1
    }, 8, ["disabled", "loading"]), _createVNode(_component_el_button, {
      type: "warning",
      plain: "",
      disabled: !$setup.canUseLegacyEventAdmin || !$setup.managerTargetUid || !$setup.currentDetailId,
      loading: $setup.managerLoading && $setup.managerAction === 'set-organiser',
      onClick: _cache[13] || (_cache[13] = $event => $setup.submitLegacyManagerAction('set-organiser'))
    }, {
      default: _withCtx(() => [_createTextVNode(" 设为工作人员 ")]),
      _: 1
    }, 8, ["disabled", "loading"]), _createVNode(_component_el_button, {
      plain: "",
      disabled: !$setup.canUseLegacyEventAdmin || !$setup.managerTargetUid || !$setup.currentDetailId,
      loading: $setup.managerLoading && $setup.managerAction === 'cancel-organiser',
      onClick: _cache[14] || (_cache[14] = $event => $setup.submitLegacyManagerAction('cancel-organiser'))
    }, {
      default: _withCtx(() => [_createTextVNode(" 取消工作人员 ")]),
      _: 1
    }, 8, ["disabled", "loading"])])])]), $setup.canUseLocalSign ? (_openBlock(), _createElementBlock("section", _hoisted_57, [_createElementVNode("div", _hoisted_58, [_hoisted_59, _createVNode(_component_el_button, {
      size: "small",
      disabled: !$setup.currentDetailId,
      loading: $setup.activityExtraLoading,
      onClick: _cache[15] || (_cache[15] = $event => $setup.loadActivityExtras($setup.currentDetailId))
    }, {
      default: _withCtx(() => [_createTextVNode(" 刷新补充信息 ")]),
      _: 1
    }, 8, ["disabled", "loading"])]), _hoisted_60, _createElementVNode("div", _hoisted_61, [_createElementVNode("div", null, [_hoisted_62, _createElementVNode("strong", null, _toDisplayString($setup.activityNews.length), 1)]), _createElementVNode("div", null, [_hoisted_63, _createElementVNode("strong", null, _toDisplayString($setup.activityEvaluations.length), 1)]), _createElementVNode("div", null, [_hoisted_64, _createElementVNode("strong", null, _toDisplayString($setup.activityVotePlayers.length), 1)]), _createElementVNode("div", null, [_hoisted_65, _createElementVNode("strong", null, _toDisplayString($setup.activityMidwayStatusText), 1)])]), $setup.activityExtraMessage ? (_openBlock(), _createElementBlock("p", _hoisted_66, _toDisplayString($setup.activityExtraMessage), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_67, [_hoisted_68, _createElementVNode("div", _hoisted_69, [_createVNode(_component_el_input, {
      modelValue: $setup.announceTitle,
      "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => $setup.announceTitle = $event),
      clearable: "",
      disabled: $setup.activityWriteLoading,
      placeholder: "公告标题（activity/news/add 仅确认 title）"
    }, null, 8, ["modelValue", "disabled"]), _createVNode(_component_el_button, {
      type: "primary",
      plain: "",
      disabled: !$setup.currentDetailId || !$setup.announceTitle.trim(),
      loading: $setup.activityWriteLoading && $setup.activityWriteAction === 'news',
      onClick: _cache[17] || (_cache[17] = $event => $setup.submitActivityWriteAction('news'))
    }, {
      default: _withCtx(() => [_createTextVNode(" 发布公告 ")]),
      _: 1
    }, 8, ["disabled", "loading"]), _createVNode(_component_el_input_number, {
      modelValue: $setup.evaluationStar,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => $setup.evaluationStar = $event),
      min: 1,
      max: 5,
      disabled: $setup.activityWriteLoading
    }, null, 8, ["modelValue", "disabled"]), _createVNode(_component_el_input, {
      modelValue: $setup.evaluationPics,
      "onUpdate:modelValue": _cache[19] || (_cache[19] = $event => $setup.evaluationPics = $event),
      clearable: "",
      disabled: $setup.activityWriteLoading,
      placeholder: "评价图片 pics，可空；正文 key 未确认不提交"
    }, null, 8, ["modelValue", "disabled"]), _createVNode(_component_el_button, {
      type: "warning",
      plain: "",
      disabled: !$setup.currentDetailId,
      loading: $setup.activityWriteLoading && $setup.activityWriteAction === 'evaluate',
      onClick: _cache[20] || (_cache[20] = $event => $setup.submitActivityWriteAction('evaluate'))
    }, {
      default: _withCtx(() => [_createTextVNode(" 提交评价 ")]),
      _: 1
    }, 8, ["disabled", "loading"]), _createVNode(_component_el_input, {
      modelValue: $setup.votePlayerId,
      "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => $setup.votePlayerId = $event),
      clearable: "",
      disabled: $setup.activityWriteLoading,
      placeholder: "投票项 playId，可点下方投票项自动填入"
    }, null, 8, ["modelValue", "disabled"]), _createVNode(_component_el_button, {
      type: "success",
      plain: "",
      disabled: !$setup.currentDetailId || !$setup.votePlayerId.trim(),
      loading: $setup.activityWriteLoading && $setup.activityWriteAction === 'vote',
      onClick: _cache[22] || (_cache[22] = $event => $setup.submitActivityWriteAction('vote'))
    }, {
      default: _withCtx(() => [_createTextVNode(" 投票 ")]),
      _: 1
    }, 8, ["disabled", "loading"]), _createVNode(_component_el_button, {
      type: "danger",
      plain: "",
      disabled: !$setup.currentDetailId,
      loading: $setup.activityWriteLoading && $setup.activityWriteAction === 'midway',
      onClick: _cache[23] || (_cache[23] = $event => $setup.submitActivityWriteAction('midway'))
    }, {
      default: _withCtx(() => [_createTextVNode(" 中途签到 ")]),
      _: 1
    }, 8, ["disabled", "loading"])])]), $setup.activityJoinMaterial?.needMaterial ? (_openBlock(), _createElementBlock("div", _hoisted_70, [_hoisted_71, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.activityJoinMaterial.list, field => {
      return _openBlock(), _createElementBlock("article", {
        key: field.id || field.name
      }, [_createElementVNode("span", null, _toDisplayString(field.name || '未命名字段'), 1), _createElementVNode("small", null, _toDisplayString($setup.displayValue(field.type)) + " · " + _toDisplayString($setup.readableFlag(field.required)), 1)]);
    }), 128))])) : _createCommentVNode("", true), $setup.activityNews.length ? (_openBlock(), _createElementBlock("div", _hoisted_72, [_hoisted_73, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.activityNews, item => {
      return _openBlock(), _createElementBlock("article", {
        key: item.id || item.title
      }, [_createElementVNode("span", null, _toDisplayString(item.title || '未命名公告'), 1), _createElementVNode("small", null, _toDisplayString($setup.formatExtraTime(item.createTime)) + " " + _toDisplayString(item.realname || ''), 1), item.content ? (_openBlock(), _createElementBlock("p", _hoisted_74, _toDisplayString(item.content), 1)) : _createCommentVNode("", true)]);
    }), 128))])) : _createCommentVNode("", true), $setup.activityEvaluations.length ? (_openBlock(), _createElementBlock("div", _hoisted_75, [_hoisted_76, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.activityEvaluations, item => {
      return _openBlock(), _createElementBlock("article", {
        key: item.id || item.uid
      }, [_createElementVNode("span", null, _toDisplayString(item.realname || '匿名用户') + " · " + _toDisplayString($setup.displayValue(item.star)) + " 星", 1), _createElementVNode("small", null, _toDisplayString($setup.formatExtraTime(item.createTime)) + " " + _toDisplayString(item.level ? `等级 ${item.level}` : ''), 1), item.content ? (_openBlock(), _createElementBlock("p", _hoisted_77, _toDisplayString(item.content), 1)) : _createCommentVNode("", true)]);
    }), 128))])) : _createCommentVNode("", true), $setup.activityVotePlayers.length ? (_openBlock(), _createElementBlock("div", _hoisted_78, [_hoisted_79, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.activityVotePlayers, player => {
      return _openBlock(), _createElementBlock("article", {
        key: player.id || player.uid
      }, [_createElementVNode("span", null, _toDisplayString(player.title || player.realname || '未命名参赛项'), 1), _createElementVNode("small", null, "票数 " + _toDisplayString($setup.displayValue(player.voteNum)), 1), _createVNode(_component_el_button, {
        size: "small",
        text: "",
        onClick: $event => $setup.votePlayerId = String(player.id || '')
      }, {
        default: _withCtx(() => [_createTextVNode("填入 playId")]),
        _: 2
      }, 1032, ["onClick"])]);
    }), 128))])) : _createCommentVNode("", true), $setup.activityMidwayRecords.length ? (_openBlock(), _createElementBlock("div", _hoisted_80, [_hoisted_81, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.activityMidwayRecords, record => {
      return _openBlock(), _createElementBlock("article", {
        key: record.id || record.uid
      }, [_createElementVNode("span", null, _toDisplayString(record.realname || record.uid || '未知成员'), 1), _createElementVNode("small", null, _toDisplayString($setup.formatExtraTime(record.signTime)), 1), record.signAddress ? (_openBlock(), _createElementBlock("p", _hoisted_82, _toDisplayString(record.signAddress), 1)) : _createCommentVNode("", true)]);
    }), 128))])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_83, [_createVNode(_component_el_button, {
      disabled: !$setup.currentDetailId,
      loading: $setup.actionLoading,
      type: "primary",
      onClick: _cache[24] || (_cache[24] = $event => $setup.joinCurrentEvent($setup.currentDetailId))
    }, {
      default: _withCtx(() => [_createTextVNode(" 报名活动 ")]),
      _: 1
    }, 8, ["disabled", "loading"]), _createVNode(_component_el_button, {
      disabled: !$setup.currentDetailId,
      loading: $setup.actionLoading,
      type: "danger",
      plain: "",
      onClick: _cache[25] || (_cache[25] = $event => $setup.cancelCurrentEvent($setup.currentDetailId))
    }, {
      default: _withCtx(() => [_createTextVNode(" 取消报名 ")]),
      _: 1
    }, 8, ["disabled", "loading"])])])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["modelValue"]), _createElementVNode("section", _hoisted_84, [_createElementVNode("div", _hoisted_85, [_hoisted_86, _createElementVNode("form", {
    class: "search-box",
    onSubmit: _cache[28] || (_cache[28] = _withModifiers((...args) => $setup.searchEvents && $setup.searchEvents(...args), ["prevent"]))
  }, [_createVNode(_component_el_input, {
    modelValue: $setup.searchQuery,
    "onUpdate:modelValue": _cache[27] || (_cache[27] = $event => $setup.searchQuery = $event),
    clearable: "",
    placeholder: "搜索活动名称、地点或关键词"
  }, null, 8, ["modelValue"]), _createElementVNode("div", _hoisted_87, [_createVNode(_component_el_button, {
    "native-type": "button",
    disabled: !$setup.canUseLocalSign || $setup.loading,
    onClick: $setup.fetchCanSignEvents
  }, {
    default: _withCtx(() => [_createTextVNode(" 可签到 ")]),
    _: 1
  }, 8, ["disabled", "onClick"]), _createVNode(_component_el_button, {
    "native-type": "button",
    disabled: !$setup.canUseLocalSign || $setup.loading,
    onClick: $setup.fetchMyClassEvents
  }, {
    default: _withCtx(() => [_createTextVNode(" 我的 ")]),
    _: 1
  }, 8, ["disabled", "onClick"]), _createVNode(_component_el_button, {
    "native-type": "button",
    disabled: !$setup.canUseLocalSign || $setup.loading,
    onClick: $setup.fetchManagedClassEvents
  }, {
    default: _withCtx(() => [_createTextVNode(" 管理 ")]),
    _: 1
  }, 8, ["disabled", "onClick"]), _createVNode(_component_el_button, {
    "native-type": "button",
    disabled: !$setup.canUseLocalSign || $setup.loading,
    onClick: $setup.fetchCollectedClassEvents
  }, {
    default: _withCtx(() => [_createTextVNode(" 收藏 ")]),
    _: 1
  }, 8, ["disabled", "onClick"]), _createVNode(_component_el_button, {
    type: "primary",
    "native-type": "submit"
  }, {
    default: _withCtx(() => [_createTextVNode("搜索")]),
    _: 1
  })])], 32)]), _createElementVNode("div", _hoisted_88, [_createElementVNode("article", _hoisted_89, [_hoisted_90, _createElementVNode("div", _hoisted_91, _toDisplayString($setup.currentPage), 1)]), _createElementVNode("article", _hoisted_92, [_hoisted_93, _createElementVNode("div", _hoisted_94, _toDisplayString($setup.events.length), 1)]), _createElementVNode("article", _hoisted_95, [_hoisted_96, _createElementVNode("div", _hoisted_97, _toDisplayString($setup.registerableCount), 1)])])]), _withDirectives((_openBlock(), _createElementBlock("section", _hoisted_98, [$setup.events.length ? (_openBlock(), _createElementBlock("div", _hoisted_99, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.events, event => {
    return _openBlock(), _createElementBlock("button", {
      key: $setup.activityIdOf(event) || event.title || event.name,
      class: "activity-card",
      type: "button",
      onClick: $event => $setup.handleRowClick(event)
    }, [_createElementVNode("div", _hoisted_101, [_createElementVNode("span", _hoisted_102, "#" + _toDisplayString($setup.activityIdOf(event) || '—'), 1), _createElementVNode("h3", null, _toDisplayString(event.title || event.name || '未命名活动'), 1), _createElementVNode("p", null, _toDisplayString(event.address || '未填写地点'), 1)]), _createElementVNode("div", _hoisted_103, [_createElementVNode("span", {
      class: _normalizeClass(['status-pill', $setup.canRegister(event.startline, event.deadline) ? 'open' : 'closed'])
    }, _toDisplayString($setup.canRegister(event.startline, event.deadline) ? '可报名' : '未开放'), 3), _createElementVNode("span", null, _toDisplayString($setup.displayValue(event.credit)) + " 分", 1), _createElementVNode("span", null, _toDisplayString(event.category || event.statusName || '活动'), 1)]), _createElementVNode("div", _hoisted_104, [_createElementVNode("span", null, _toDisplayString($setup.formatTime(event.sTime)), 1), _createElementVNode("span", null, _toDisplayString($setup.formatTime(event.eTime)), 1)])], 8, _hoisted_100);
  }), 128))])) : !$setup.loading ? (_openBlock(), _createBlock(_component_el_empty, {
    key: 1,
    description: "暂无活动，换个关键词试试。"
  })) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_105, [_createVNode(_component_el_button, {
    onClick: $setup.prevPage,
    disabled: $setup.currentPage === 1 || $setup.loading
  }, {
    default: _withCtx(() => [_createTextVNode("上一页")]),
    _: 1
  }, 8, ["onClick", "disabled"]), _createElementVNode("span", null, "第 " + _toDisplayString($setup.currentPage) + " 页", 1), _createVNode(_component_el_button, {
    onClick: $setup.nextPage,
    disabled: !$setup.hasNextPage || $setup.loading
  }, {
    default: _withCtx(() => [_createTextVNode("下一页")]),
    _: 1
  }, 8, ["onClick", "disabled"])])])), [[_directive_loading, $setup.loading]])]);
}